/* Magia Swiat – koszyk: dodawanie z katalogu do szuflady i zamiana na tanszy zestaw.
   Korzysta z tych samych zdarzen co motyw Horizon, wiec szuflada i licznik odswiezaja sie same.
   Bez JS formularze dzialaja zwyczajnie (wysylka do /cart/add). */
import { CartLinesUpdateEvent } from '@shopify/events';

const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

function sectionIds() {
  return Array.from(document.querySelectorAll('cart-items-component'))
    .map((el) => el.dataset.sectionId)
    .filter(Boolean)
    .join(',');
}

async function readCart() {
  const res = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
  if (!res.ok) throw new Error('cart ' + res.status);
  return res.json();
}

function openDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (drawer && typeof drawer.open === 'function' && !drawer.isOpen) drawer.open();
}

function busy(btn, on) {
  if (!btn) return;
  btn.disabled = on;
  btn.classList.toggle('is-busy', on);
}

/* 1. "Dodaj do koszyka" w katalogu */
document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-mgx-add]')) return;
  if (!document.getElementById('cart-drawer')) return;
  event.preventDefault();

  const btn = form.querySelector('[type="submit"]');
  const err = form.querySelector('[data-mgx-err]');
  const data = new FormData(form);
  const id = data.get('id');
  if (!id) return;
  const ids = sectionIds();
  if (ids) data.append('sections', ids);
  data.append('sections_url', window.location.pathname);

  busy(btn, true);
  if (err) err.hidden = true;
  const deferred = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(id), quantity: Number(data.get('quantity')) || 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const res = await fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      body: data,
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    });
    const json = await res.json();
    if (!res.ok || json.status) throw new Error(json.description || json.message || 'add');
    const cart = await readCart();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, itemCount: cart.item_count, sections: json.sections, source: 'mgx-catalog', didError: false },
    });
    openDrawer();
  } catch (error) {
    deferred.reject(error);
    if (err) {
      err.textContent = error && error.message && error.message !== 'add' ? error.message : 'Nie udało się dodać do koszyka. Odśwież stronę i spróbuj ponownie.';
      err.hidden = false;
    }
  } finally {
    busy(btn, false);
  }
});

/* 2. Zamiana pozycji na zestaw w szufladzie koszyka */
document.addEventListener('click', async (event) => {
  const btn = event.target instanceof Element ? event.target.closest('[data-mgx-swap]') : null;
  if (!btn || btn.disabled) return;
  event.preventDefault();

  const key = btn.getAttribute('data-key');
  const to = btn.getAttribute('data-to');
  const box = btn.closest('[data-mgx-up]');
  const err = box ? box.querySelector('[data-mgx-up-err]') : null;
  if (!key || !to) return;

  busy(btn, true);
  if (err) err.hidden = true;
  const deferred = CartLinesUpdateEvent.createPromise();
  btn.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'update',
      context: 'cart',
      lines: [{ id: key, quantity: 0 }],
      promise: deferred.promise,
    })
  );

  try {
    const updates = {};
    updates[key] = 0;
    updates[to] = 1;
    const res = await fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates, sections: sectionIds(), sections_url: window.location.pathname }),
    });
    const json = await res.json();
    if (!res.ok || json.status) throw new Error(json.description || 'update');
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(json),
      detail: { items: json.items, itemCount: json.item_count, sections: json.sections, source: 'mgx-upsell', didError: false },
    });
  } catch (error) {
    deferred.reject(error);
    busy(btn, false);
    if (err) err.hidden = false;
  }
});